import { render, staticRenderFns } from "./TermsOfUse.vue?vue&type=template&id=3a3200b4&scoped=true&"
var script = {}
import style0 from "./TermsOfUse.vue?vue&type=style&index=0&id=3a3200b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a3200b4",
  null
  
)

export default component.exports